// extracted by mini-css-extract-plugin
export default {"ToastDescriptionWrapper":"_ToastDescriptionWrapper--_knvf","InfoTextWrapper":"_InfoTextWrapper--xNmHA","Title":"_Title--p3K0K","Button":"_Button--TMnc8"};